
import { EAgencyType } from '@/common/enum/account';
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CarService from '@/services/car.service';
// import { DebounceTime } from '@/common/decorator';

@Component({})
export default class EditThirdpartnarModal extends Vue {
  loading = false;
  fetching = false;

  @lazyInject(CarService)
  carService!: CarService;

  @Prop({
    default: () => {
      return null;
    },
  })
  thirdpartnar?: {
    shopId: string | number;
    name: string;
    uid: string | number;
    type: EAgencyType;
  };

  isVisible = false;

  fromType: any = '';

  typeData = 0;

  EAgencyType = EAgencyType;

  carShopCode = '';


  sionOptions: any = [];

  permissionOptions: any[] = [];

  form: {
    name: string;
    uid: number | string | undefined;
  } = {
      name: '',
      uid: undefined,
    };

  @lazyInject(ShopService)
  protected shopService!: ShopService;

  async submit() {
    if (!this.form.uid) {
      return;
    }

    if (this.loading) {
      return;
    }

    try {
      this.loading = true;
      console.log(this.form);
      const params = {
        gdUserId: this.form.uid,
      };
      const res = await this.carService.postCarOrderBindAgent(this.carShopCode, params);

      if (res) {
        const msg = this.thirdpartnar == null ? '添加成功' : '修改成功';
        this.$message.success(msg);

        await $delay(500);
        this.$emit('refresh', true);
        this.isVisible = false;
        this.reset();
      }
    } catch (error) {
      this.$message.info(`${error}`);
    } finally {
      this.loading = false;
    }
  }
  // @DebounceTime()
  async searchPermission(val: any) {
    const res = await this.carService.getCarShopQueryUserInfo({
      userName: val,
    });
    this.permissionOptions = res;
  }

  handleChange(value: any) {
    console.log(value);
    this.sionOptions = value;
    this.form.uid = value.key;
  }

  reset() {
    this.form = {
      uid: '',
      name: '',
    };
    this.permissionOptions = [];
    this.sionOptions = [];
    if (this.loading) {
      this.loading = false;
    }
  }

  open(val: any) {
    this.form.name = val.agent_name;
    console.log(val);
    this.carShopCode = val.car_shop_code;
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
    this.reset();
    this.$emit('close', true);
  }
}
